/**
 * usePraticaDetail — F-006 Phase 5 (IMPL-P5-004).
 *
 * Loads `/api/v1/archivio/:id` via TanStack Query. The `refresh` helper
 * invalidates the cache so the user can manually re-check whether documents
 * have become available (e.g. when the operator just uploaded the ricevuta).
 *
 * NOTE: there is no polling here — the UI shows a static "non disponibile"
 * message + manual "Aggiorna" button, per the F-006 spec.
 */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getPraticaDetail } from '../lib/archivio-client';

export function usePraticaDetail(id: string) {
  const qc = useQueryClient();
  const query = useQuery({
    queryKey: ['archivio', 'detail', id],
    queryFn: () => getPraticaDetail(id),
    // staleTime inherits the QueryClient default (30s) — see lib/query-client.ts.
    enabled: !!id,
  });

  const refresh = () => qc.invalidateQueries({ queryKey: ['archivio', 'detail', id] });

  return {
    data: query.data,
    error: query.error,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    refresh,
  };
}
